export const firebaseConfig = {
  apiKey: "AIzaSyD5JbUQnr2WfhqRXdeLejBS514Tz8OoFeA",
  authDomain: "yasen-6cb1a.firebaseapp.com",
  databaseURL: "https://yasen-6cb1a.firebaseio.com",
  projectId: "yasen-6cb1a",
  storageBucket: "yasen-6cb1a.appspot.com",
  messagingSenderId: "327986966999",
  appId: "1:327986966999:web:adb4ed70a8264376ed1b92"
};
